import { useCallback, useEffect, useState } from "react";
import { cms } from "../../api/cms.service";
import type { CmsPage } from "../../types/cms";

export type CmsPagesStatus = "loading" | "ready" | "failed";

export function useCmsPages() {
  const [cmsPages, setCmsPages] = useState<CmsPage[]>([]);
  const [cmsPagesStatus, setCmsPagesStatus] = useState<CmsPagesStatus>("loading");

  const reloadCmsPages = useCallback(async () => {
    try {
      const { pages } = await cms.getPages();
      setCmsPages(pages);
      setCmsPagesStatus("ready");
    } catch (err) {
      console.error("[useCmsPages] failed to load pages", err);
      setCmsPagesStatus("failed");
    }
  }, []);

  useEffect(() => {
    reloadCmsPages();
  }, [reloadCmsPages]);

  return { cmsPages, cmsPagesStatus, reloadCmsPages };
}
